module.exports = __webpack_public_path__ + "img/icon_message_loading.68d71c13.png";